import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import React from 'react';
import { useSelector } from 'react-redux';
import { getAppUser } from '../../../app/appSelectors';
import classNames from 'classnames';

interface IUserStatusCongratulationsHeaderProps {
    className?: string;
}

function UserStatusCongratulationsHeader(props: IUserStatusCongratulationsHeaderProps) {
    const { className } = props;
    const profile = useSelector(getAppUser);
    const { getLangPath } = useLangContext();

    return <h2 className={classNames('mb-0', className)}>
        {getLangPath(`user_statuses.statuses.${profile.user_status}.achievement.title`)}
    </h2>
}

export default UserStatusCongratulationsHeader;
